import * as React from "react";
import styled from "styled-components";
import { spacing } from "../theme/spacing";
import { device } from "../theme/breakpoints";

const Section = styled.section`
  margin: ${spacing[10]} 0;

  @media only screen and ${device["$lg"]} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

const ProjectSection = ({ children }) => {
  return <Section>{children}</Section>;
};

export default ProjectSection;
